import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61c7a8a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrapper user_wrapper" }
const _hoisted_2 = { class: "top_buttons_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "back_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "flex"
}
const _hoisted_5 = { class: "tab_body" }
const _hoisted_6 = { class: "profile_wrapper" }
const _hoisted_7 = { class: "photo_wrapper" }
const _hoisted_8 = { class: "img_wrapper" }
const _hoisted_9 = { class: "img_block position-relative" }
const _hoisted_10 = { class: "photo_text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "camera_img",
  src: "/assets/img/camera.svg"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "data_wrapper" }
const _hoisted_14 = { class: "user_info_wrapper" }
const _hoisted_15 = { class: "user_info_title" }
const _hoisted_16 = { class: "w-100" }
const _hoisted_17 = { class: "user_info_fi" }
const _hoisted_18 = { class: "user_info_phone" }
const _hoisted_19 = { class: "user_info_body" }
const _hoisted_20 = { class: "first_block_wrapper" }
const _hoisted_21 = { class: "one_block_wrapper mt-3" }
const _hoisted_22 = { class: "block_label" }
const _hoisted_23 = { class: "block_info" }
const _hoisted_24 = { class: "block_row" }
const _hoisted_25 = { class: "two_block_wrapper mt-3" }
const _hoisted_26 = { class: "block_label" }
const _hoisted_27 = { class: "block_info" }
const _hoisted_28 = { class: "two_block_wrapper mt-3" }
const _hoisted_29 = { class: "block_label" }
const _hoisted_30 = { class: "block_info" }
const _hoisted_31 = { class: "second_block_wrapper" }
const _hoisted_32 = { class: "block_row" }
const _hoisted_33 = { class: "two_block_wrapper mt-3" }
const _hoisted_34 = { class: "block_label" }
const _hoisted_35 = { class: "block_info club_name_info" }
const _hoisted_36 = { class: "two_block_wrapper mt-3" }
const _hoisted_37 = { class: "block_label" }
const _hoisted_38 = { class: "flex" }
const _hoisted_39 = { class: "in_club_status" }
const _hoisted_40 = { class: "block_row" }
const _hoisted_41 = { class: "two_block_wrapper mt-3" }
const _hoisted_42 = { class: "block_label" }
const _hoisted_43 = { class: "block_info" }
const _hoisted_44 = { class: "two_block_wrapper mt-3" }
const _hoisted_45 = { class: "block_label" }
const _hoisted_46 = { class: "block_info" }

export function render(_ctx, _cache) {
  const _component_addPhoto = _resolveComponent("addPhoto")
  const _component_linkPassCard = _resolveComponent("linkPassCard")
  const _component_passCardAlert = _resolveComponent("passCardAlert")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showAddPhoto)
      ? (_openBlock(), _createBlock(_component_addPhoto, {
          key: 0,
          userId: _ctx.userId,
          onClose: _ctx.closeAddPhotoWindow
        }, null, 8, ["userId", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showlinkPassCard)
      ? (_openBlock(), _createBlock(_component_linkPassCard, {
          key: 1,
          userId: _ctx.userId,
          onClose: _cache[0] || (_cache[0] = $event => (_ctx.showlinkPassCard = false)),
          onLinkPassCard: _ctx.createPassCard
        }, null, 8, ["userId", "onLinkPassCard"]))
      : _createCommentVNode("", true),
    (_ctx.isShowAwaitingCard)
      ? (_openBlock(), _createBlock(_component_passCardAlert, {
          key: 2,
          title: _ctx.passCardAlertTitle,
          onClose: _ctx.closeAwaitingCard
        }, null, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.go(-1))),
          class: "button button_back"
        }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('user.view.back')), 1)
        ]),
        (_ctx.hasConnection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("a", {
                class: "link_card_button",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.showlinkPassCard = true))
              }, _toDisplayString(_ctx.$t('user.view.link_card')), 1),
              (_ctx.user?.hasPassCard)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "untie_card",
                    onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.deactivatePassCard && _ctx.deactivatePassCard(...args)))
                  }, _toDisplayString(_ctx.$t('user.view.untie_card')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('user.view.photo')), 1),
                (_ctx.user?.photoUrl)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "photo",
                      style: _normalizeStyle({ 'background-image': `url(${_ctx.user?.photoUrl})` })
                    }, null, 4))
                  : _createCommentVNode("", true),
                (_ctx.hasUploadPhotoPermission)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "camera",
                      onClick: _cache[4] || (_cache[4] = $event => (_ctx.showAddPhoto = true))
                    }, _hoisted_12))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.user?.lastName) + " " + _toDisplayString(_ctx.user?.firstName), 1),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.addPhoneMask(_ctx.user?.phone) || _ctx.$t('user.view.phone_absent')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('user.view.email')), 1),
                      _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.user?.email), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('user.view.role')), 1),
                      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.user?.mainRoleName ? _ctx.$t(_ctx.user?.mainRoleName) : "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('user.view.sex')), 1),
                      _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.user?.sex ? _ctx.$t('user.view.male') : _ctx.$t('user.view.female')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('user.view.club')), 1),
                      _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.user?.lastClubName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t('user.view.stay')), 1),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.user?.isInClub ? 'dot dot_active' : 'dot dot_disable')
                        }, null, 2),
                        _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.user?.isInClub ? _ctx.$t('user.view.in_club') : _ctx.$t('user.view.not_in_club')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('user.view.last_in')), 1),
                      _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.getFormatedDate(_ctx.user?.lastInDate, "DD.MM.yyyy HH:mm") || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t('user.view.last_out')), 1),
                      _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.getFormatedDate(_ctx.user?.lastOutDate, "DD.MM.yyyy HH:mm") || '-'), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}